import React, {useEffect} from "react";
import { useSelector, useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { rateAnswer, requestForUpdate } from "../../API/api";
import { Actions } from "../../Action";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";
import { CURRENT_ROLE } from "../../API/url";
import styles from "./RatingComponent.module.css";



const RatingComponent = ({ rating, id, helpful, isDisable }) => {
  const currentRoute = useLocation();
  const dispatch = useDispatch();
  const {getRatingsDataInSearchSuggestions} = bindActionCreators(Actions, dispatch);


  const ratingPercentage = (ratingClass) => {
    if (rating.percentage === null) {
      return `0%`;
    }
    if (ratingClass === "1") {
      return rating.percentage["1"] === undefined
        ? "0%"
        : `${rating.percentage["1"]}%`;
    }
    if (ratingClass === "4") {
      let star2 =
        rating.percentage["2"] === undefined || rating.percentage["2"] === null
          ? 0
          : parseInt(rating.percentage["2"]);
      let star3 =
        rating.percentage["3"] === undefined || rating.percentage["3"] === null
          ? 0
          : parseInt(rating.percentage["3"]);
      let star4 =
        rating.percentage["4"] === undefined || rating.percentage["4"] === null
          ? 0
          : parseInt(rating.percentage["4"]);
      let allStar = star2 + star3 + star4;
      return `${allStar}%`;
    }
    if (ratingClass === "5") {
      return rating.percentage["5"] === undefined ||
        rating.percentage["5"] === null
        ? "0%"
        : `${rating.percentage["5"]}%`;
    }
  };

  const renderTooltip = (props) => (
    <Tooltip {...props} className={styles.tooltipratings}>
      <span className={styles.ratingInfoGlobal}>
        <p style={{ color: "black" }}>Seeker Rating</p>
        <div
          style={{ textAlign: "center", color: "#949494", fontSize: "12px" }}
        >
          &nbsp;
          <span>
            {rating.overallRating === null
              ? 0
              : rating.overallRating.toFixed(1)}
          </span>
          <span>/5</span>
        </div>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div
            className="progress"
            style={{
              width: "90%",
              textAlign: "center",
              height: "10px",
              borderRadius: "2px",
            }}
          >
            <div
              className="progress-bar progress-bar-warning"
              role="progressbar"
              aria-valuenow="50"
              aria-valuemin="0"
              aria-valuemax="100"
              style={{
                width: ratingPercentage("1"),
                backgroundColor: "#ed260c",
              }}
            ></div>
            <div
              className="progress-bar progress-bar-warning"
              role="progressbar"
              aria-valuenow="50"
              aria-valuemin="0"
              aria-valuemax="100"
              style={{
                width: ratingPercentage("4"),
                backgroundColor: "#fead02",
              }}
            ></div>
            <div
              className="progress-bar progress-bar-warning"
              role="progressbar"
              aria-valuenow="100"
              aria-valuemin="0"
              aria-valuemax="100"
              style={{
                width: ratingPercentage("5"),
                backgroundColor: "#61d937",
              }}
            ></div>
          </div>
        </div>
        <div
          style={{
            textAlign: "center",
            color: "#949494",
            fontSize: "12px",
            marginBottom: "5px",
            marginTop: "5px",
          }}
        >
          <span>
            {rating.globalRatings == null ? 0 : rating.globalRatings} global
            ratings
          </span>
        </div>
        <br />
      </span>
    </Tooltip>
  );

  const ratingState = useSelector((state) => state.domain);
  // const dispatch = useDispatch();
  const { updateSearchData2 } = bindActionCreators(Actions, dispatch);

  const successfulHelpful = (message) => {
    return (
      <>
        <p style={{ fontSize: "14px", fontWeight: "bold" }}>Success!</p>
        <span style={{ fontSize: "12px" }}>{message}</span>
      </>
    );
  };

  const helpfulTrigger = () => {
    if(helpful === undefined){
      return;
    }
    requestForUpdate(helpful)
      .then((res) => {
        if (res !== undefined) {
        }
      })
      .catch((err) => {});
  };
  const onClickThumbs = (ratingNumber) => {
    if (ratingNumber === 4 || ratingNumber === 5) {
      if(currentRoute.pathname.includes("/search") ){
        helpfulTrigger();
      }
    }
    let isAnswerUuid = ratingState.answerUuidList.includes(id);
    let payload = {
      rating: ratingNumber,
      answerUuid: isDisable ? null : id,
      docId: isDisable ? id : null,
      feedback: rating.feedback,
    };
    rateAnswer(
      payload,
      updateSearchData2,
      ratingState.ratings
    );
  };
    rating.rating = rating.rating === null ? rating.overallRating : rating.rating;
  
  return (
    <OverlayTrigger placement="bottom" overlay={renderTooltip}>
      <div className={styles.ratingDiv}>
        <span
          className={styles.thumbsDown}
          onClick={CURRENT_ROLE === 'CM' ? null :() => onClickThumbs(1)}
          style={{ color: rating.rating === 1 ? "red" : null }}
        >
          <i className="fa fa-solid fa-thumbs-down fa-border-all"></i>
        </span>
        <span
          className={styles.thumbsUp}
          onClick={CURRENT_ROLE === 'CM' ? null :() => onClickThumbs(4)}
          style={{
            color:
              rating.rating === 2 || rating.rating === 3 || rating.rating === 4
                ? "#ffa500"
                : null,
          }}
        >
          <i className="fa fa-solid fa-thumbs-up fa-border-all"></i>
        </span>
        &nbsp;&nbsp;
        <span
          className={styles.thumbsDoubleUp}
          onClick={CURRENT_ROLE === 'CM' ? null :() => onClickThumbs(5)}
          style={{ color: rating.rating === 5 ? "#A4BE7B" : null }}
        >
          <i
            className="fa fa-solid fa-thumbs-up"
            style={{
              transform: "rotate(16deg)",
              marginRight: "-10px",
              zIndex: 1000,
              left: "9px",
              marginLeft: "-7px",
            }}
          ></i>
          <i className="fa fa-solid fa-thumbs-up"></i>
        </span>
      </div>
    </OverlayTrigger>
  );
};

export default RatingComponent;
